import {
  R4_SCHEMA,
  type ResourceSchema,
  type SchemaElement,
} from './r4-schema.generated';

export type { ResourceSchema, SchemaElement };

export function getResourceSchema(
  resourceType: string,
): ResourceSchema | undefined {
  return R4_SCHEMA[resourceType];
}

/**
 * Top-level renderable elements of a resource type, in spec order.
 * Nested (backbone) element paths are excluded — they render through their
 * parent element.
 */
export function topLevelElements(
  resourceType: string,
): readonly [string, SchemaElement][] {
  const schema = getResourceSchema(resourceType);
  if (!schema) return [];
  return Object.entries(schema).filter(([path]) => !path.includes('.'));
}

/** Top-level Reference-typed element names — the resource's slot names per spec. */
export function referenceKeys(resourceType: string): readonly string[] {
  return topLevelElements(resourceType)
    .filter(([, element]) => element.t === 'Reference')
    .map(([path]) => path);
}

/** 'effectiveDateTime' → 'Effective date time'; 'code' → 'Code'. */
export function humanizeElementName(path: string): string {
  const last = path.split('.').pop() ?? path;
  const spaced = last.replace(/([a-z0-9])([A-Z])/g, '$1 $2').toLowerCase();
  return spaced.charAt(0).toUpperCase() + spaced.slice(1);
}
